/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import TextBlock from '@component/common/block/text-block';

// ############### type ###############
interface IProps {
  studiedCount: number;
  totalCount: number;
}

// ############### styled ###############
const Wrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OuterCircle = styled.div<{ $percentage: number }>`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: conic-gradient(
    from 225deg,
    ${color.BROWN_2} 0deg,
    ${color.BROWN_2} ${(props) => props.$percentage * 2.7}deg,
    ${color.GRAY_BOX_BORDER_COLOR} ${(props) => props.$percentage * 2.7}deg,
    ${color.GRAY_BOX_BORDER_COLOR} 270deg,
    transparent 135deg
  );
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const InnerCircle = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${color.WHITE_1};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

const ProgressText = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PieProgress: React.FC<IProps> = ({ studiedCount, totalCount }) => {
  const percentage = totalCount > 0 ? Math.round((studiedCount / totalCount) * 100) : 0;

  return (
    <Wrapper>
      <OuterCircle $percentage={percentage} />
      <InnerCircle />
      <ProgressText>
        <TextBlock
          text={`${percentage}%`}
          design={{
            text: { size: 'medium', color: color.BROWN_2, bold: true },
            box: { alignX: 'center' },
          }}
        />
        <TextBlock
          text={`${studiedCount} / ${totalCount}`}
          design={{
            text: { size: 'tiny', color: color.GRAY_1, bold: false },
            box: { alignX: 'center' },
          }}
        />
      </ProgressText>
    </Wrapper>
  );
};

export default PieProgress;
